import theme from '../../theme';

export const DialogTitleSx = {
  color: theme.palette.customColors.gray[950],
  fontSize: '24px',
  fontWeight: 600,
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  position: 'relative',
};
